import siteSiteLaunchTheme from './siteSiteLaunchTheme';

const siteSiteLaunchDarkTheme = {
    siteLaunch: {
        ...siteSiteLaunchTheme.siteLaunch,
    },
};

export default siteSiteLaunchDarkTheme;
